import { render, staticRenderFns } from "./BaseSearch.vue?vue&type=template&id=32445326"
import script from "./BaseSearch.vue?vue&type=script&lang=js"
export * from "./BaseSearch.vue?vue&type=script&lang=js"
import style0 from "./BaseSearch.vue?vue&type=style&index=0&id=32445326&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports